export default __webpack_public_path__ + "static/hero-bg-tabl-9c36f55497efd7d2614c9af21ac09d2e.png";